
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import WeEmpty from '@/components/We/empty.vue'
import { stampTransTime } from "@/utils/time";

@Component({
    components: {
        WeEmpty
    },
})
export default class extends Vue {
    @Prop({ default: false }) private value!: boolean;
    @Prop({ default: "user" }) private type!: string;
    @Prop({ default: "" }) private mid!: string;

    private stampTransTime = stampTransTime;
    private dialogVisible = false;
    private checkType = 'platform'
    private checkInfo = {};
    private showEmpty = false;
    private searching = false;
    private searchOption = [
        {label:'流水编号',val:2},
        {label:'资金编号',val:1}
    ]

    private search = {
        keyword:'',
        type:'',
        search_type:1
    }

    @Watch("value")
    changeStatus() {
        if (this.value) {
            // (this as any).$refs["pwdRef"].orderDialogVisible = true;
            this.dialogVisible = this.value
        }
    }

    private close() {
        this.checkInfo = {};
        this.search = {
            keyword:'',
            type:'',
            search_type:1
        }
        this.$emit("input", false);
    }

    @Watch('search.type') clearSearch(val:number){
        this.search.keyword = '';
        this.showEmpty = false;
        this.checkInfo = {};
    }

    @Watch('search.search_type') clear(val:number){
        this.search.keyword = '';
        this.showEmpty = false;
        this.checkInfo = {};
    }

    destroyed(){
        this.close()
    }

    getAccount(item:any,type:string){
        if(!item)return '--'
        if(type == 'account'){
            return `${item.nick || '--'}(${item.account})`
        }else{
            let role = item.type == 0 ? '系统' : '用户'
            return `${item.nick || '--'}(${role})`
        }

    }

    async goSearch(){
        if(!this.search.keyword){
            this.$message({
                message:'请输入关键词',
                type:'error'
            })
            return;
        }
        if(this.searching)return;
        this.searching = true;
        const res = await (this as any).$http.searchNo(this.search);
        if(res.code == 1000){
            this.checkInfo = res.data;
            this.showEmpty = Object.keys(res.data).length ? false : true;
        }else{
            this.$message({
                message:res.msg,
                type:'error'
            })
            this.showEmpty = true;
        }
        this.searching = false;
    }
}
